



















































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CourseCenterApplicationController } from '@/services/request.service';
import { fixIOSScroll, getSchoolInfo } from '@/utils/utils';
import moment, { Moment } from 'moment';
import config from '@/school.config';

@Component
export default class Step1 extends Vue {
  @Prop() public userInfo!: any;
  @Prop() public draftInfo!: any;
  public examForm: any;
  public config = config;
  public fixIOSScroll = fixIOSScroll;
  public subjectsList: Array<any> = ['生化', '物理', '历史', '地理', '政治'];

  public beforeCreate(): void {
    this.examForm = this.$form.createForm(this);
  }

  public get school() {
    return getSchoolInfo().shortName;
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  @Watch('userInfo', { immediate: true })
  public setFormContent(): void {
    const isDraft = this.$route.query.isDraft;
  }

  @Watch('draftInfo', { immediate: false })
  public setFormDraftContent(): void {
    const list = this.draftInfo.examSubject ? this.draftInfo.examSubject.split(',') : [];
    this.$nextTick(() => {
      this.examForm.setFieldsValue({
        examSubjectList: list,
        juniorThirdLastExam: this.draftInfo.juniorThirdLastExam,
        juniorThirdLastExamRank: this.draftInfo.juniorThirdLastExamRank,
        midtermExam: this.draftInfo.midtermExam,
        midtermExamOther: this.draftInfo.midtermExamOther,
        midtermExamRank: this.draftInfo.midtermExamRank,
        mockFirstExam: this.draftInfo.mockFirstExam,
        mockFirstExamRank: this.draftInfo.mockFirstExamRank,
        mockSecondExam: this.draftInfo.mockSecondExam,
        mockSecondExamRank: this.draftInfo.mockSecondExamRank,
        standardExamIelts: this.draftInfo.standardExamIelts,
        standardExamOther: this.draftInfo.standardExamOther,
        standardExamSsat: this.draftInfo.standardExamSsat,
        standardExamToefl: this.draftInfo.standardExamToefl,
        midtermExamNumber: this.draftInfo.midtermExamNumber,
      });
    });
  }

  public getExamFormInfo(e: any): any {
    e.preventDefault();
    this.examForm.validateFieldsAndScroll((err: any, values: any) => {
      if (!err) {
        values.examSubject = values.examSubjectList ? values.examSubjectList.join(',') : '';
        this.transValues(values);
      } else {
        this.transValues(null);
      }
    });
  }

  public transValues(values: any): void {
    const key = 'getValue';
    if (this.$listeners[key]) {
      this.$emit('getValue', values);
      return;
    }
    this.$emit('changeStep', 'next', 'step1', values);
  }

  public getDraftContent(e: any): any {
    e.preventDefault();
    const values = this.examForm.getFieldsValue();
    values.examSubject = values.examSubjectList ? values.examSubjectList.join(',') : '';
    return values;
  }
}
